'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var focusMouseRgxp = /\:focus-mouse/;
var focusKeyboardRgxp = /\:focus-keyboard/;

exports.default = function (context, content, selectors, parents, line, column, length) {
  if (context === 2) {
    selectors.forEach(function (selector, index) {
      if (selector.match(focusMouseRgxp)) {
        var cleanSelector = selector.replace(':focus-mouse', ':focus');
        selectors[index] = '[data-whatinput=mouse] ' + cleanSelector;
      }

      if (selector.match(focusKeyboardRgxp)) {
        var _cleanSelector = selector.replace(':focus-keyboard', ':focus');

        selectors[index] = '[data-whatinput=keyboard] ' + _cleanSelector + ',[data-whatinput=initial] ' + _cleanSelector;
      }
    });
  }

  return content;
};